import React, { useEffect, useState } from "react";
// import { getData, putData } from "../global/Globalapi";
import { getData,putData } from "../global/Globalapi";
import { showAlert } from "../Components/DynamicComp/Alert";
import { useNavigate } from 'react-router-dom';
const Settings = () => {
  const navigate = useNavigate(); 
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editValues, setEditValues] = useState({}); // store temporary values

  // Fetch all settings from API
  const fetchSettings = async () => {
    try {
      const response = await getData("/settings");
      setSettings(response.data);
      // Initialize editValues
      const initialValues = {};
      response.data.forEach((s) => (initialValues[s.key_name] = s.key_value));
      setEditValues(initialValues);
    } catch (err) {
      console.error("Error fetching settings:", err);
    } finally {
      setLoading(false);
    }
  };

  // Save updated setting to backend
  const updateSetting = async (key) => {
    try {
      await putData(`/settings/${key}`, { key_value: editValues[key] });
     showAlert({ 
               type: "success", 
               title: "updated",
               message: "Setting updated successfully.",   
             }, () => {
               navigate("/menu", { replace: true });
             });
      fetchSettings();
    } catch (err) {
      console.error("Update failed:", err);
      showAlert({
                type: 'error',
                message: err.message || 'failed to update setting ❌',
                title: 'error',
              });
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  if (loading) return <p className="text-center py-10 text-gray-600">Loading settings...</p>;

  return (
<div className="p-4 max-w-6xl mx-auto bg-white shadow-2xl rounded-2xl border border-gray-200">
  <h2 className="text-2xl md:text-3xl font-extrabold mb-8 text-gray-900 text-left tracking-wide border-b-4 border-red-600 pb-2">
    Application Settings
  </h2>
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
    {settings.map((setting) => (
      <div
        key={setting.id}
        className="flex flex-col items-start bg-gray-50 rounded-xl py-5 px-3 border border-gray-200 shadow-sm"
      >
        <label className="font-semibold text-base text-gray-700 uppercase tracking-wide mb-2 block">
          {setting.key_name.replace(/_/g, " ")}
        </label>
        <div className="flex items-center w-full">
          <input
            type="text"
            value={editValues[setting.key_name] || ""}
            onChange={(e) =>
              setEditValues({
                ...editValues,
                [setting.key_name]: e.target.value,
              })
            }
            className="border border-gray-300 rounded-lg px-3 py-2 bg-white mr-2 w-full focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
            placeholder={`Set ${setting.key_name.replace(/_/g, " ")}`}
          />
          <button
            onClick={() => updateSetting(setting.key_name, editValues[setting.key_name])}
            className="bg-red-600 hover:bg-red-700 transition text-white font-semibold px-5 py-2 rounded-lg shadow min-w-[70px]"
          >
            Save
          </button>
        </div>
      </div>
    ))}
  </div>
</div>




  );
};

export default Settings;